(function () {
  var banner = document.getElementById('izoTrustBanner');
  if (!banner) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var fill = banner.querySelector('.stars-fill');
  if (fill) fill.style.clipPath = 'inset(0 100% 0 0)';

  function animate(el, target, decimals) {
    var dur = 1400, start = null;
    function fmt(v) {
      return decimals > 0
        ? v.toFixed(decimals).replace('.', ',')
        : Math.round(v).toLocaleString('de-DE');
    }
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(target * eased);
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = fmt(target);
    }
    requestAnimationFrame(step);
  }

  function run() {
    if (fill) fill.style.clipPath = '';
    var s = banner.querySelector('.score-value');
    var c = banner.querySelector('.review-count-num');
    if (s) animate(s, parseFloat(s.dataset.target), 1);
    if (c) animate(c, parseInt(c.dataset.target, 10), 0);
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { run(); io.disconnect(); }
      });
    }, { threshold: 0.4 });
    io.observe(banner);
  } else { run(); }
})();